<template>
    <ElementLayout :parent="parent" :element="element">
        <v-switch color="primary" v-model="element.value" @change="fieldChanged" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 

export default {
    data() {
        return {
            // value: null,
            // originalValue: null,
        }
    },

    components: {
        ElementLayout,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {

    },

    methods: {
        fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue)
            this.originalValue = newVal
        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// SwitchControl.vue?1154ceb0